import PropTypes from "prop-types";

const propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired
};

export default propTypes;
